import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = ({ onSchedule }) => (
  <footer className="border-t border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
      <p className="font-display font-extrabold tracking-tight text-[15vw] lg:text-[11rem] leading-[0.85] text-duo select-none">Sweet Results</p>
      <div className="mt-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4 space-y-4">
          <Logo />
          <button data-testid="footer-schedule-btn" onClick={onSchedule} className="block text-sm text-[#5B95D6] hover:underline underline-offset-4">Schedule your STD test →</button>
        </div>
        <p data-testid="footer-disclaimer-text" className="md:col-span-8 text-sm text-slate-400 leading-relaxed">
          <span className="text-[#FFB800] font-semibold">Disclaimer:</span> Sweet Results and its AI Nurse provide general educational information only. Nothing on this site is medical advice, a diagnosis or a substitute for care from a licensed healthcare provider. If you have symptoms or a possible exposure, schedule an STD test and speak with a clinician. In an emergency, call your local emergency number.
        </p>
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-400">
        <p>© {new Date().getFullYear()} Sweet Results. All rights reserved.</p>
        <div className="flex gap-6">
          <Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-white">Privacy Policy</Link>
          <Link data-testid="footer-terms-link" to="/terms" className="hover:text-white">Terms of Service</Link>
          <a data-testid="footer-affiliate-link" href="#creators" className="hover:text-white">Creators</a>
        </div>
      </div>
    </div>
  </footer>
);
